import { useState } from 'react';

import type { PerformanceAttribute } from 'types/cloudCatalog';
import { cn } from 'helpers/classnames';
import { isMobileViewport } from 'utils/viewportUtil';
import { getTechSpecDisplay } from 'helpers/ProductUtils';
import { SUPPORT_ATTRIBUTE } from 'constants/product';
import useWindowSize from 'hooks/useWindowSize';
import { TechSpecsTitle } from 'components/productdetail/accordions/TechSpecsTitle';
import { TechSpecsDrawer } from 'components/productdetail/accordions/TechSpecsDrawer';

interface TechSpecDisplayProps {
  attribute: PerformanceAttribute;
}

export const TechSpecsDisplay = ({ attribute }: TechSpecDisplayProps) => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const { iconUrl, title, value } = getTechSpecDisplay(attribute);
  const isSupportAttribute = attribute.attributeId === SUPPORT_ATTRIBUTE;
  const { width: windowWidth = 0 } = useWindowSize();
  const isMobile = isMobileViewport(windowWidth);

  if (isSupportAttribute) {
    return (
      <div key={attribute.attributeId} className="flex items-center gap-x-4">
        <img className="h-10 w-10 object-contain" src={iconUrl} alt={title} />
        <button type="button" className={cn('text-left', { 'cursor-pointer': isSupportAttribute })} onClick={() => setIsDrawerOpen(true)}>
          <TechSpecsTitle attribute={attribute} text={title} />
          <p className="lumon:body-s-plus-medium">{value}</p>
        </button>
        <TechSpecsDrawer isMobile={isMobile} isOpen={isDrawerOpen} setIsOpen={setIsDrawerOpen} />
      </div>
    );
  }

  return (
    <div key={attribute.attributeId} className="flex items-center gap-x-4">
      <img className="h-10 w-10 object-contain" src={iconUrl} alt={title} />
      <div className="text-left">
        <TechSpecsTitle attribute={attribute} text={title} />
        <p className={cn({ 'text-sm': attribute.value.length > 12 }, 'lumon:body-s-plus-medium')}>{value}</p>
      </div>
      <TechSpecsDrawer isMobile={isMobile} isOpen={isDrawerOpen} setIsOpen={setIsDrawerOpen} />
    </div>
  );
};
